import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { IonicPageModule } from 'ionic-angular';
import { PlazaSelectPlanChoosePage } from './plaza-select-plan-choose';

@NgModule({
  declarations: [
    PlazaSelectPlanChoosePage,
  ],
  imports: [
    IonicPageModule.forChild(PlazaSelectPlanChoosePage),
    TranslateModule.forChild()
  ],
})
export class PlazaSelectPlanChoosePageModule {}



// WEBPACK FOOTER //
// ./src/pages/plaza-select-plan-choose/plaza-select-plan-choose.module.ts